import * as envs from '../envs'
import type { Config } from './types'

export const config: Config = envs

export * from './config'
export default config
